import React from "react";
import useRevealOnIntersect from "../hooks/useRevealOnIntersect";
import "./Features.css";

function Features() {
  const features = [
    {
      icon: "🚀",
      title: "Operational Speed",
      desc: "Performance-first systems designed to reduce friction for users and teams.",
      points: ["Lean delivery cycles", "Low-latency architecture"],
    },
    {
      icon: "🔒",
      title: "Secure by Default",
      desc: "Security patterns are built into the architecture instead of added later.",
      points: ["Zero-trust thinking", "Hardened deployment posture"],
    },
    {
      icon: "⚙️",
      title: "Tailored Systems",
      desc: "Solutions shaped around the way your operations actually run.",
      points: ["Industry-specific fit", "Scalable implementation"],
    },
    {
      icon: "💡",
      title: "Forward Looking",
      desc: "Modern tooling and pragmatic innovation focused on measurable outcomes.",
      points: ["AI-aware planning", "Long-term maintainability"],
    },
  ];

  useRevealOnIntersect(".ftx-reveal", { threshold: 0.16 });

  return (
    <section id="features" className="features" aria-label="Why choose Nexite">
      <div className="ftx-container">
        <header className="ftx-header ftx-reveal" data-reveal="up" style={{ "--d": "40ms" }}>
          <span className="ftx-pill">Why Nexite</span>
          <h2>Technology decisions grounded in outcomes, not noise.</h2>
          <p>
            We combine engineering discipline, design clarity, and business context so solutions stay usable,
            secure, and scalable after launch.
          </p>
        </header>

        <div className="ftx-grid">
          {features.map(({ icon, title, desc, points }, idx) => (
            <article
              key={title}
              className="ftx-card ftx-reveal"
              data-reveal="up"
              style={{ "--d": `${80 + idx * 70}ms` }}
            >
              <div className="ftx-card-top">
                <div className="ftx-icon">{icon}</div>
                <span className="ftx-index">0{idx + 1}</span>
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
              <ul className="ftx-points">
                {points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="ftx-summary ftx-reveal" data-reveal="up" style={{ "--d": "220ms" }}>
          <strong>Built for real operations.</strong>
          <span>From planning to rollout, we keep reliability, supportability, and user adoption in view.</span>
        </div>
      </div>
    </section>
  );
}

export default Features;
